import { useNavigate } from 'react-router-dom';
import api from '../../api/CallManagerApi';
import { BaseUserInfo } from '../../interface/BaseUserInfo';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import UnsavedReportAlertModal from './UnsavedReportAlertModal';
import { ACCOUNT } from '../../enum/AccountEnum';
import CommonHeader, { HeaderMenuItem } from './CommonHeader';
import useHeaderNavigationGuard from './useHeaderNavigationGuard';

export interface HeaderProps {
  user: BaseUserInfo;
  isBtnDisabled: boolean;
  isDisableHalfWrittenBtn: boolean;
}

const Header: React.FC<HeaderProps> = ({ user, isBtnDisabled, isDisableHalfWrittenBtn }) => {
  const globalDisplayName = useSelector((state: RootState) => state.displayName.displayName);
  const globalInstitutionName = useSelector((state: RootState) => state.institution.name);
  const { wrapWithNavigationGuard, isDisplayModal, handleCloseModal, handleClickOk } = useHeaderNavigationGuard();
  const navigate = useNavigate();

  const handleClickReportsPageButton = () => navigate('reports');
  const moveCreateNewReportPage = () => navigate('regist/lesson');
  const moveHalfWrittenReportPage = () => {
    localStorage.setItem(user._id + '_editType', 'halfWritten');
    navigate('regist/lesson');
  };
  const handleClickUserManagementPageButton = () => navigate('userManagement');
  const handleClickInfoPageButton = () => navigate('info');
  const handleClickLogoutButton = async () => {
    await api.Logout();
    navigate('login');
  };

  const menuItems: HeaderMenuItem[] = [
    {
      key: 'new-report',
      label: '新規登録',
      onClick: moveCreateNewReportPage,
      disabled: isBtnDisabled,
    },
    {
      key: 'half-written',
      label: '書きかけ編集',
      onClick: moveHalfWrittenReportPage,
      disabled: isBtnDisabled || isDisableHalfWrittenBtn,
    },
    {
      key: 'reports',
      label: '利用報告一覧',
      onClick: () => wrapWithNavigationGuard(handleClickReportsPageButton),
    },
    {
      key: 'user-management',
      label: 'ユーザー管理',
      onClick: () => wrapWithNavigationGuard(handleClickUserManagementPageButton),
    },
    {
      key: 'documents',
      label: '関連資料',
      href: 'https://sartras.or.jp/hokoku/hokoku-documents/',
      newTab: true,
      showExternalIcon: true,
    },
  ];

  return (
    <>
      <CommonHeader
        displayLines={[globalInstitutionName, `${ACCOUNT.MANAGER}： ${globalDisplayName} 様`]}
        menuItems={menuItems}
        onClickLogo={() => wrapWithNavigationGuard(handleClickReportsPageButton)}
        onClickInfo={() => wrapWithNavigationGuard(handleClickInfoPageButton)}
        onClickLogout={() => wrapWithNavigationGuard(handleClickLogoutButton)}
        showOpinionAction
      />
      <UnsavedReportAlertModal isDisplayModal={isDisplayModal} handleCloseModal={handleCloseModal} handleClickOk={handleClickOk} />
    </>
  );
};

export default Header;
